import { defineStore } from 'pinia';
import { reactive } from '@nuxtjs/composition-api';
/**
 * TODO: review possibility to use sharedRef
 */
export const useFiltersStore = defineStore('filters', {
  state: () => ({
    selectedFilters: {},

    // CURRENT selecting\unselecting filter and its options state BEFORE sending filters to server.
    // Useful to store to be able to restore this value if aggregation of current filter is empty
    // to keep current filter unchanged while selecting\unselecting any option
    currentFilterCache: {},

    // State of LAST SELECTED(!) filter.
    // Is changing to the current Filter data while selecting action
    // or changing to the previous Selected filter if current unselecting action led to zero selected options.
    // Is required to send to the server within EACH getFacetData request to get properly calculated aggregation data;
    lastSelectedFilter: {}
  }),

  actions: {
    setSelectedFilters(selectedFilters, categoryId) {
      if(categoryId) {
        this.selectedFilters[categoryId] = reactive(selectedFilters);
      }
    }
  }
});
